import {
  getABTestConfig,
  lingoChatCheckoutABTestRouteConfig,
} from '@/config/abTestConfig'
import { isTrialFunnel } from '@/helpers/trialFunnel'
import { isVoFunnel } from '@/helpers/voFunnel'
import ABTestSectionOutlet from '@app-studio-web/ui/components/ABTestSectionOutlet'
import { Navigate, useLocation } from 'react-router-dom'

export default function CheckoutOutlet() {
  const { pathname } = useLocation()

  // Come-back visitors who previously entered the trial funnel should always be
  // served the trial sales page, even when they return through the normal
  // funnel and land on a standard (or A/B variant) plans page. Payment and
  // completion routes must not be redirected.
  const isPlansPage =
    pathname === '/checkout' ||
    pathname === '/checkout/' ||
    pathname.endsWith('/plans')

  if (isVoFunnel() && isPlansPage) {
    return <Navigate replace to="/checkout/vo-plans" />
  }

  if (isTrialFunnel() && isPlansPage) {
    return <Navigate replace to="/checkout/trial-plans" />
  }

  return (
    <ABTestSectionOutlet
      basePath="/checkout"
      getABTestConfig={getABTestConfig}
      routeConfig={lingoChatCheckoutABTestRouteConfig}
      validVariants={['baseline', 'v1', 'v2']}
      variantPathPrefixes={{ v1: 'v1', v2: 'v2' }}
    />
  )
}
